import { render } from "./InfoPopupImage.vue?vue&type=template&id=79f698a5&scoped=true"
import script from "./InfoPopupImage.vue?vue&type=script&lang=js"
export * from "./InfoPopupImage.vue?vue&type=script&lang=js"

import "./InfoPopupImage.vue?vue&type=style&index=0&id=79f698a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f698a5"]])

export default __exports__